import React from 'react';
import PropTypes from 'prop-types';
import { NAVIGATION_HEIGHT } from 'consts';
import { SEARCH_HEIGHT_DESKTOP } from '../../consts';
import usePageNavigation from '../../hooks/usePageNavigation';
import { Container, StyledSideNav, NavLink } from './styled';

const SideNav = ({ questions, className }) => {
  // scrollOffset is the amount that we need to adjust the scroll position to
  // take into account the elements with a fixed position and "negative space"
  // 60px is added to account for padding and 1px subtracted for border
  const scrollOffset = NAVIGATION_HEIGHT + SEARCH_HEIGHT_DESKTOP + 60 - 1;
  const { activeLinkIndex, createClickHandler } = usePageNavigation(
    questions,
    scrollOffset
  );

  return (
    <div className={className}>
      <Container>
        <StyledSideNav bound={NAVIGATION_HEIGHT + SEARCH_HEIGHT_DESKTOP}>
          {questions.map((question, i) => (
            <NavLink
              key={question.sys?.id}
              href={`#${question.sys?.id}`}
              $active={i === activeLinkIndex}
              onClick={createClickHandler(`question-${question.sys?.id}`)}
            >
              {question.fields.question}
            </NavLink>
          ))}
        </StyledSideNav>
      </Container>
    </div>
  );
};

SideNav.propTypes = {
  questions: PropTypes.array.isRequired,
  className: PropTypes.string
};

export default SideNav;
